import React, { useState, useEffect } from "react";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";

const EquiposForm = ({ equipo, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    equipo_desc: "",
  });

  useEffect(() => {
    if (equipo) {
      setFormData({
        equipo_desc: equipo.equipo_desc || "",
      });
    }
  }, [equipo]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <Card className="border-none shadow-none">
          <CardContent className="p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-800">
                {equipo ? "Editar equipo" : "Nuevo equipo"}
              </h2>
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700 text-xl leading-none"
              >
                ✕
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-3">
              <div>
                <label className="block text-sm font-medium">Nombre *</label>
                <input
                  type="text"
                  name="equipo_desc"
                  value={formData.equipo_desc}
                  onChange={handleChange}
                  placeholder="Equipo"
                  className="w-full border rounded-lg p-2"
                  required
                />
              </div>

              <div className="flex justify-end space-x-2 pt-4">
                <Button variant="outline" onClick={onClose} type="button">
                  Cancelar
                </Button>
                <Button type="submit">{equipo ? "Actualizar" : "Crear"}</Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default EquiposForm;
